import { ClientHelpCenterLinks, HelpCenterLinks } from 'constants/staticLinks'
import { LanguageCode } from 'translations/Language'

export const getHelpCenterLink = (language: string) => {
  switch (language) {
    case LanguageCode.FR:
      return HelpCenterLinks.FR
    case LanguageCode.DE:
      return HelpCenterLinks.DE
    case LanguageCode.EN:
    default:
      return HelpCenterLinks.EN
  }
}

/** Client-only Help Center link — unsupported languages (ES / IT / NL) fall back to EN */
export const getClientHelpCenterLink = (language: string) => {
  switch (language) {
    case LanguageCode.FR:
      return ClientHelpCenterLinks.FR
    case LanguageCode.DE:
      return ClientHelpCenterLinks.DE
    case LanguageCode.EN:
    default:
      return ClientHelpCenterLinks.EN
  }
}
